'use strict';

var RangesCalculatorService = function RangesCalculatorService(momentService) {
  function isDate(range) {
    return momentService.isMoment(range.from) && momentService.isMoment(range.to);
  }
  function getOnlyOneDaySelected(ranges) {
    if (ranges.length !== 1 || !isDate(ranges[0])) {
      return null;
    }
    if (ranges[0].from.isSame(ranges[0].to, 'day')) {
      return ranges[0].from;
    } else {
      return null;
    }
  }
  function extractDateFromFilter(filters) {
    if (!filters || filters.length !== 1) {
      return null;
    }
    return getOnlyOneDaySelected(filters[0]);
  }
  return {
    getOnlyOneDaySelected: getOnlyOneDaySelected,
    extractDateFromFilter: extractDateFromFilter
  };
};
RangesCalculatorService.$inject = ['MomentService'];
module.exports = RangesCalculatorService;